import { useHasPermission, useCurrentUser, UserMetadata } from '@shared/hooks';

export const useUserSettings = (): {
  setUserCompany: (companyId: string) => void;
  canSeeCompanyDetails: boolean;
  goToLogout: () => void;
  user: UserMetadata;
} => {
  const { userLogout, setUserCompany, user } = useCurrentUser();

  const canSeeListOfUsers = useHasPermission('COMPANY_ACCOUNT_LIST_OF_USERS', 'READ');
  const canSeeCompanyDrawer = useHasPermission('COMPANY_ACCOUNT_EDIT', 'READ');
  const canSeeCompanyDetails = canSeeListOfUsers || canSeeCompanyDrawer;

  const goToLogout = (): void => userLogout();

  return {
    canSeeCompanyDetails,
    setUserCompany,
    goToLogout,
    user,
  };
};
